import { useMatch } from 'react-router-dom';

function useIsNewSectionPage(): boolean {
  const match = useMatch('/:property/pages/new');

  return match !== null;
}

export default useIsNewSectionPage;
